import { Vector3, Color} from 'three'

import { showInfoPanel } from './ui';



export function normalizeAlphabetic(str) {
  return str
    .toLowerCase()   
    .replace(/[^a-z]+/g, '');  
}

export function rotateAroundAxisY(x, y, z, angle) {
  const vec = new Vector3(x, y, z);
  vec.applyAxisAngle(new Vector3(0, 1, 0), angle);
  return { newX: vec.x, newY: vec.y, newZ: vec.z };
}

export function rotateAroundAxis(vec, axis, angle) {
  return new Vector3(vec.x, vec.y, vec.z).applyAxisAngle(axis, angle);
}

export function rotateAroundAxisX(x, y, z, angle) {
  const vec = new Vector3(x, y, z);
  vec.applyAxisAngle(new Vector3(1, 0, 0), angle);
  return { newX: vec.x, newY: vec.y, newZ: vec.z };
}

export function rotateAroundAxisZ(x, y, z, angle) {
  const vec = new Vector3(x, y, z);
  vec.applyAxisAngle(new Vector3(0, 0, 1), angle);
  return { newX: vec.x, newY: vec.y, newZ: vec.z };
}

export function randomNormal(mean, stddev) {
  let u = 0,
    v = 0
  while (u === 0) u = Math.random()
  while (v === 0) v = Math.random()
  let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v)
  return num * stddev + mean
}

export function corAleatoria() {
  const min = 0.5;
  const r = Math.random() * (1 - min) + min;
  const g = Math.random() * (1 - min) + min;
  const b = Math.random() * (1 - min) + min;
  return new Color(r, g, b);
} 

export function setLabelVisible(mesh, size, orbitRadius, label, camera, checkedL) {
  const posLabel = new Vector3();
  mesh.getWorldPosition(posLabel);
  posLabel.y += size * 1.1;
  label.position.copy(posLabel);
  const distance = camera.position.distanceTo(posLabel);

  const show = checkedL && (
    distance < (orbitRadius < 1000 
      ? Math.abs(orbitRadius * 50) 
      : orbitRadius * 2)
  );
  return show
}

export function smoothstep(edge0, edge1, x, exponent = 1) {
  let t = (x - edge0)/(edge1 - edge0);
  t = Math.max(0, Math.min(1, t));
  t = Math.pow(t, exponent);
  return t*t*(3 - 2*t);
}



export function createInfoElement(name, imgSrc) {
  const safeKey = name.toLowerCase().replace(/\s+/g, "-");
    const icon = document.createElement("img");
    icon.src = imgSrc;
    icon.className = `info-icon info-${safeKey}`;
    icon.alt = name;
    icon.title = name;
    icon.style.width = "12px";
    icon.style.height = "12px";
    icon.style.objectFit = "contain";
    icon.style.display = 'none';
    icon.style.pointerEvents = "auto";
    icon.draggable = false;
    icon.addEventListener("click", (evt) => {
      evt.stopPropagation();
      showInfoPanel(name); 
    });
    return icon; 
}





